import React, { FC, ReactNode } from 'react';
import { Button, Skeleton } from '@mui/material';
import { ButtonAreaContent, ButtonAreaTitle, ButtonAreaWrapper } from './styles';

export interface ButtonAreaItemProps {
  title: string
  disabled?: boolean
  onClick: () => void
  endIcon?: React.ReactNode 
}

export interface ButtonAreaProps {
  title?: string
  isLoading?: boolean
  renderBorder?: boolean
  buttons: ButtonAreaItemProps[]
}

export const ButtonArea: FC<ButtonAreaProps> = (props) => {
  const { title, isLoading, renderBorder, buttons } = props;

  const loadingComponent = () => {
    const styles = { height: '33px', margin: 'auto', width: '100%', maxWidth: '47%' };
    return <>
      {buttons.map((button, index) =>
        <Skeleton key={index} variant="rounded" sx={styles} />
      )}
    </>
  }

  return (
    <ButtonAreaWrapper sx={{ border: renderBorder || title ? '1px dashed #c9c9c9' : 'none' }}>
      <ButtonAreaTitle title={title} style={{ visibility: title ? 'visible' : 'hidden' }} />
      <ButtonAreaContent>
        {isLoading && loadingComponent()}
        {!isLoading &&
          buttons.map((button, index) => (
            <Button key={index} variant='contained' color='secondary' endIcon={button.endIcon}
              onClick={button.onClick} disableElevation disabled={button.disabled}>
              {button.title}
            </Button>
          ))
        }
      </ButtonAreaContent>
    </ButtonAreaWrapper>
  );
};